import { TypographyStyles } from '@/styles'
import { Icon, List, Text } from '@/ui'
import { faCheck } from '@fortawesome/pro-regular-svg-icons'
import { dedicatedExpertSupportCopy } from './premiumCard.copy'

export const DedicatedExpertSupport = ({ isTrial }: { isTrial: boolean }) => {
  const { heading, bullets } = dedicatedExpertSupportCopy(isTrial)

  return (
    <div className="flex flex-col gap-2">
      <Text variant={TypographyStyles.DISPLAY_XXS}>{heading}</Text>
      <List className="my-0 flex flex-col gap-1">
        {bullets.map((bullet) => (
          <List.Item key={bullet} className="flex items-start gap-2">
            <Icon
              icon={faCheck}
              color="text-green-50"
              className="mt-0.5 shrink-0"
            />
            <Text variant={TypographyStyles.LABEL_SM}>{bullet}</Text>
          </List.Item>
        ))}
      </List>
    </div>
  )
}
